import { useEffect, useState } from "react";
import { api, fmtINR, API, getToken } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { StatusBadge } from "../../components/StatusBadge";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { DownloadSimple } from "@phosphor-icons/react";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../../components/ui/table";

export default function CustomerInvoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/customer/invoices").then((r) => setRows(r.data)); }, []);

  const billed = rows.filter((j) => j.status === "completed").reduce((a, j) => a + (j.amount || 0), 0);
  const pending = rows.filter((j) => ["assigned", "accepted", "in_progress"].includes(j.status)).reduce((a, j) => a + (j.amount || 0), 0);

  return (
    <>
      <PageHeader title="Invoices" subtitle="Your billing & payment history" />
      <div className="p-8 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-xl">
          <Card className="rounded-sm p-6 border-border" data-testid="invoice-billed">
            <p className="label-caps">Total Billed (Completed)</p>
            <p className="font-heading text-3xl font-bold mt-2 text-green-700">{fmtINR(billed)}</p>
          </Card>
          <Card className="rounded-sm p-6 border-border" data-testid="invoice-pending">
            <p className="label-caps">In Progress Value</p>
            <p className="font-heading text-3xl font-bold mt-2 text-amber-700">{fmtINR(pending)}</p>
          </Card>
        </div>
        <div className="border border-border rounded-sm bg-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/50">
                <TableHead>Service</TableHead><TableHead>Partner</TableHead>
                <TableHead>Date</TableHead><TableHead className="text-right">Amount</TableHead><TableHead>Status</TableHead><TableHead>Invoice</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="invoices-table">
              {rows.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-10 text-muted-foreground">No invoices yet</TableCell></TableRow>}
              {rows.map((j) => (
                <TableRow key={j.id} className="hover:bg-secondary/30">
                  <TableCell className="font-semibold">{j.service_type} · {j.product_category}</TableCell>
                  <TableCell>{j.partner_name || "—"}</TableCell>
                  <TableCell className="text-sm">{j.scheduled_date || j.created_at?.slice(0, 10)}</TableCell>
                  <TableCell className="text-right font-mono font-semibold">{fmtINR(j.amount)}</TableCell>
                  <TableCell><StatusBadge value={j.status === "completed" ? "complete" : j.status} /></TableCell>
                  <TableCell>
                    {j.invoice_name ? (
                      <a href={`${API}/jobs/${j.id}/invoice?auth=${getToken()}`} target="_blank" rel="noreferrer">
                        <Button variant="outline" size="sm" className="rounded-sm gap-1.5" data-testid={`customer-invoice-download-${j.id}`}><DownloadSimple size={14} /> Download</Button>
                      </a>
                    ) : <span className="text-xs text-muted-foreground">—</span>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}
